export default __webpack_public_path__ + "static/media/shirt.90b0478b.svg";